"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_gtm_module_1 = __importDefault(require("react-gtm-module"));
const gtmShouldRun = process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging';
const initialize = () => {
    if (gtmShouldRun) {
        react_gtm_module_1.default.initialize({
            gtmId: process.env.GTM_ID,
            auth: process.env.GTM_AUTH,
            preview: process.env.GTM_PREVIEW,
        });
    }
};
const dataLayer = (payload) => {
    if (gtmShouldRun) {
        react_gtm_module_1.default.dataLayer({
            dataLayer: {
                ...payload,
                event: `c_${payload.event}`,
            },
        });
    }
};
exports.default = { initialize, dataLayer };
